import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography, CircularProgress, Button } from '@material-ui/core';
import IconSave from '@material-ui/icons/SaveAltOutlined';
import { ExportResult } from './ExportResult'
import { authHeader } from '../auth-header'

const styles = theme => ({
    header: {
        padding: theme.spacing.unit * 2,
    },
    space: {
        margin: theme.spacing.unit,
    }
});

export class LastExportResult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
            reportLoad: false,
        };
    }
    componentDidMount() {
        fetch('api/UploadExport/GetLastResult', { headers: authHeader() })
            .then(res => {
                if (res.status === 204) {
                    return null;
                }
                else if (res.status === 200) {
                    return res.json()
                }
            })
            .then(resX => { console.log(resX); this.setState({ data: resX, loading: false }); });
    }
    downFile() {
        this.setState({ reportLoad: true });
        fetch('api/UploadExport/GetLastResultPdf', { headers: authHeader() })
            .then(res => {
                this.setState({ reportLoad: false });
                if (res.status === 200) {
                    //return res.json();
                    return res.blob()
                }
                else
                    return null;
            })
            .then(dataId => {
                if (dataId !== null) {
                    this.downloadData('chybnik.pdf', dataId);
                    //window.location.href = 'api/Files/' + dataId.id;
                }
            });
    }

    downloadData(filenameForDownload, data) {
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(data, filenameForDownload);
        }
        else {
            var textUrl = URL.createObjectURL(data);
            var element = document.createElement('a');
            element.setAttribute('href', textUrl);
            element.setAttribute('download', filenameForDownload);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();
            document.body.removeChild(element);
        }
    }

    render() {
        const { classes } = this.props;
        return <Paper className={classes.header}>
            <Typography variant="h6" component="div">
                Posledný export
            {this.state.loading === false && this.state.data !== null && this.state.data.errors !== null && this.state.data.errors.length > 0 &&
                    <Button disabled={this.state.reportLoad} className={classes.space} onClick={e => { this.downFile() }} variant="contained" color="secondary">
                        <IconSave fontSize="small" />Stiahnuť ako PDF</Button>
                }
            </Typography>
            {this.state.loading && <CircularProgress />}
            {this.state.loading === false && this.state.data === null && <Typography variant='body2'>V databáze nebola nájdená informácia o poslednom exporte</Typography>}

            {this.state.loading === false && this.state.data !== null && <ExportResult resData={this.state.data} />}
        </Paper>
    }
}

LastExportResult.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LastExportResult);


// WEBPACK FOOTER //
// ./src/components/insem/LoadExportLast.jsx